import React, { Component } from "react";

import NumberFormat from "react-number-format";
import { transactionID, clientInfo } from "../../../services/helpers";
import axios from "axios";
import Swal from "sweetalert2";

import ImageMakeNewRecharge from "../images/recharge-make-new-recharge.png";

class ChooseAmount extends Component {
  constructor(props) {
    super(props);

    axios.defaults.headers.common["Authorization"] =
      "Bearer " + clientInfo().accessToken;
    axios.defaults.headers.common["Content-Type"] = "application/json";

    this.state = {
      chooseAmount: [],
      hasAnyPromotion: false,
    };
  }

  getValues = async () => {
    this.props.setLoading(1);

    const response = await axios.post(
      "https://www.pagtel.com.br/Hub360Correios/v2/GetValues",
      {
        transactionId: transactionID("GTV"),
        MSISDN: clientInfo().number,
      }
    );

    let promotions = response.data.valueList.filter((value) => {
      return value.promotion;
    });

    this.props.setLoading(0);

    this.setState({
      chooseAmount: response.data.valueList,
      hasAnyPromotion: promotions.length !== 0,
    });
  };

  chooseAmount = (amount) => {
    this.props.setAmount(amount);
    this.props.step(3);
  };

  componentDidMount = async () => {
    this.getValues();
  };

  render() {
    const { chooseAmount, hasAnyPromotion } = this.state;

    return (
      <div className="choose-amount-container step ">
        <h2>Selecione o valor da recarga</h2>
        <ul className="select-amount">
          {chooseAmount.map((amount, key) => {
            return (
              <li
                className="cursor-pointer"
                key={key}
                onClick={() => {
                  this.chooseAmount(amount);
                }}
              >
                {" "}
                <img src={amount.note} />{" "}
              </li>
            );
          })}
        </ul>
        {hasAnyPromotion && (
          <ul className="footer-rules">
            <li>
              *Ao comprar 4 recargas antecipadas, você ganhará mais 2 recargas.
            </li>
            <li>
              *Seus benefícios serão renovados a cada 30 dias pelos próximos 6
              meses.
            </li>
            <li>
              *Os benefícios não usados em um mês se acumularão para o mês
              seguinte, conforme o termo de adesão.
            </li>
          </ul>
        )}
      </div>
    );
  }
}

export default ChooseAmount;
